import styled from "@emotion/styled";
import {  Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";

import React, { FC } from "react";

interface ProductSGRecommendedShopProps {
  is_active: boolean;
}

const ProductSGRecommendedShop: FC<ProductSGRecommendedShopProps> = ({ is_active }) => {
  return (
 
    <FormWrapper>
      <Form.Item
        label="วิธีขาย (Sales Guide)"
        name="sg_recommended_shop"
        //rules={[{ required: is_active, message: "กรุณากรอกร้านค้าเป้าหมาย" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}

      >
        <TextArea  placeholder="วิธีขาย (Sales Guide) ควรเสนอใคร ช่องทางไหน" showCount maxLength={5000}  rows={10} />
      </Form.Item>
    </FormWrapper>

  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>ตัวอย่าง “แนะนำร้านค้าเป้าหมาย”</h6>
      <p style={{ color: "black" }}>
        1. ขายดีอันดับ 1 เป็นร้านขายของฝาก ขายเป็นขวด เป็นของฝาก แนะนำสินค้าควรวางไว้ใกล้ๆ ตู้ขายน้ำจะดีมากๆ 
      </p>
      <p style={{ color: "black" }}>
        2. ขายดีอันดับ 2 เป็นร้านนวด และสปา ใช้สินค้าในการให้บริการแก่ผู้มาใช้บริการ อาจจะซื้อเป็นขวดในกรณีที่ยังใช้ไม่เยอะ หรืออาจจะซื้อเป็นถุงหากต้องการซื้อปริมาณมากๆ โดยนำมาแช่เท้าร่วมกับน้ำร้อน เพื่อช่วยให้เลือดลมหมุนเวียนดี จะสามารถเพิ่มมูลค่าให้กับการบริการได้อีก 50 บาทต่อเคส หากใช้เกลือชมพูเป็นตัวเลือกในการแช่
      </p>
    </div>
  );
};


export default ProductSGRecommendedShop;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
